import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class LocationService {

    constructor(private http: HttpClient) { }

    getCityById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}/cities/search`);
    }

    searchCityByNameTerm(searchTerm: any) {
        return this.http.get<any>(`${environment.apiUrl}/cities/search/${searchTerm}`);
    }

    getAllCountries() {
        return this.http.get<any>(`${environment.apiUrl}/locations/countries`);
    }

    getCitiesBySelectedCountryId(countryId: number) {
        return this.http.get<any>(`${environment.apiUrl}/locations/countries/${countryId}/cities`);
    }

    getCitiesBySelectedStateId(stateId: number) {
        return this.http.get<any>(`${environment.apiUrl}/locations/states/${stateId}/cities`);
    }

    getLocationByZipcode(zipcode: any) {
        return this.http.get<any>(`${environment.apiUrl}/locations/zipcodes/${zipcode}/info`);
    }

    getFrontlineCommunityResults() {
        return this.http.get<any>(`${environment.apiUrl}/locations/frontline-community-results/`);
    }

    getFrontlineDistributionData() {
        return this.http.get<any>(`${environment.apiUrl}/locations/frontline-distribution-data`);
    }

    getStates(countryId: number) {
        return this.http.get<any>(`${environment.apiUrl}/locations/countries/${countryId}/states`);
    }
}